module.exports = __webpack_public_path__ + "img/right_slide.784967c2.svg";